<script lang="ts">
    import type {UserAccountReactivePageData, UserAccountStaticPageData} from '../types';
    import {getLocalization} from 'core/svelte-context/context';
    import {getPageContext} from 'shared/layouts/page-context';
    import KpVerticalButtonsPanel from 'shared/ui-widgets/vertical-buttons-panel/KpVerticalButtonsPanel.svelte';
    import UserAccountEditButtons from '../components/UserAccountEditButtons.svelte';

    const localize = getLocalization();
    const pageContext = getPageContext<UserAccountStaticPageData, UserAccountReactivePageData>();

    const user = pageContext.staticData.user;
    const detailView = pageContext.staticData.detailView;
</script>

<KpVerticalButtonsPanel>
    <span slot="heading">{localize(/* @kp-localization konto.UserManagement */ 'konto.UserManagement')}</span>
    <UserAccountEditButtons {user} {detailView}/>
</KpVerticalButtonsPanel>